/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Abbreviated dispute info in resolution response
 * @export
 * @interface DisputeSummary
 */
export interface DisputeSummary {
    /**
     * 
     * @type {string}
     * @memberof DisputeSummary
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof DisputeSummary
     */
    status?: string;
    /**
     * 
     * @type {number}
     * @memberof DisputeSummary
     */
    resolvedAt?: number;
    /**
     * The outcome the admin recorded when resolving the dispute.
     * @type {string}
     * @memberof DisputeSummary
     */
    resolution?: string;
}

/**
 * Check if a given object implements the DisputeSummary interface.
 */
export function instanceOfDisputeSummary(value: object): value is DisputeSummary {
    return true;
}

export function DisputeSummaryFromJSON(json: any): DisputeSummary {
    return DisputeSummaryFromJSONTyped(json, false);
}

export function DisputeSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisputeSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'status': json['status'] == null ? undefined : json['status'],
        'resolvedAt': json['resolvedAt'] == null ? undefined : json['resolvedAt'],
        'resolution': json['resolution'] == null ? undefined : json['resolution'],
    };
}

export function DisputeSummaryToJSON(json: any): DisputeSummary {
    return DisputeSummaryToJSONTyped(json, false);
}

export function DisputeSummaryToJSONTyped(value?: DisputeSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'resolvedAt': value['resolvedAt'],
        'resolution': value['resolution'],
    };
}

